import { get, post } from '@/utils/https';

export const fetchFilesContracts = (params) => get('/api/app/v1/files/contracts', params);
export const fetchFilesInvoices = (params) => get('/api/app/v1/files/invoices', params);
export const fetchFilesInvoicesCsvDetails = (items) =>
  post('/api/app/v1/files/invoices/csv-details', { items });
export const fetchFilesExpenses = (params) => get('/api/app/v1/files/expenses', params);
export const fetchFilesDeboursNotes = (params) => get('/api/app/v1/files/debours-notes', params);
export const fetchFilesKyc = (params) => get('/api/app/v1/files/kyc', params);

/** Liste CRA avec champs extra (mission_feedback ou carbone) — même route que la liste CRA, query `cra_extra`. */
export const fetchFilesActivityReportExtras = (params) => get('/api/app/v1/activity-report', params);

export default {
  fetchFilesContracts,
  fetchFilesInvoices,
  fetchFilesInvoicesCsvDetails,
  fetchFilesExpenses,
  fetchFilesDeboursNotes,
  fetchFilesKyc,
  fetchFilesActivityReportExtras,
};
